<template>
  <div>
    <div v-for="(item, index) in queryMessages" :key="index">
      <v-layout row v-if="item && item.items" class="ptb-1">
        <div v-html="item.title"></div>
        <div class="pl-2">
          <span v-for="(subItem, subIndex) in item.items" :key="subIndex" class="messages-subItem">
            {{ subItem }}
          </span>
        </div>
      </v-layout>
      <div v-else v-html="item" class="ptb-1"></div>
    </div>
  </div>
</template>

<script>
import '../../../style/_variables.scss'
export default {
  name: 'CanvasProblems',
  computed: {
    queryMessages: { get () { return this.$store.state.queryState.queryMessage } }
  }
}
</script>

<style lang="scss" scoped>
  .messages-subItem {
    background-color: $blue-grey-600;
    color: $bg-primary;
    margin: 2px;
    padding: 1px 3px;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/ResultsContainer/CanvasProblems.vue